import { defineMessages } from 'gatsby-plugin-react-intl';

export const cardBadgesCopy = defineMessages({
  // legacy products
  'prospectus.2u-product-card.pill-text.course': {
    id: 'prospectus.2u-product-card.pill-text.course',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Course',
  },
  'prospectus.2u-product-card.pill-text.microbachelors': {
    id: 'prospectus.2u-product-card.pill-text.microbachelors',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'MicroBachelors®',
  },
  'prospectus.2u-product-card.pill-text.micromasters': {
    id: 'prospectus.2u-product-card.pill-text.micromasters',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'MicroMasters®',
  },
  'prospectus.2u-product-card.pill-text.xseries': {
    id: 'prospectus.2u-product-card.pill-text.xseries',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'XSeries',
  },
  'prospectus.2u-product-card.pill-text.professional-certificate': {
    id: 'prospectus.2u-product-card.pill-text.professional-certificate',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Professional Certificate',
  },
  // 2U Products
  'prospectus.2u-product-card.pill-text.executive-education': {
    id: 'prospectus.2u-product-card.pill-text.executive-education',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Executive Education',
  },
  'prospectus.2u-product-card.pill-text.boot-camp': {
    id: 'prospectus.2u-product-card.pill-text.boot-camp',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Boot Camp',
  },
  'prospectus.2u-product-card.pill-text.bachelors': {
    id: 'prospectus.2u-product-card.pill-text.bachelors',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Bachelor\'s Degree',
  },
  'prospectus.2u-product-card.pill-text.masters': {
    id: 'prospectus.2u-product-card.pill-text.masters',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Master\'s Degree',
  },
  'prospectus.2u-product-card.pill-text.doctorate': {
    id: 'prospectus.2u-product-card.pill-text.doctorate',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Doctoral Program',
  },
  'prospectus.2u-product-card.pill-text.certificate': {
    id: 'prospectus.2u-product-card.pill-text.certificate',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Certificate Program',
  },
  'prospectus.2u-product-card.pill-text.license': {
    id: 'prospectus.2u-product-card.pill-text.license',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Licensure Program',
  },
});

export const cardFooterCopy = defineMessages({
  'prospectus.2u-product-card.footer-text.emeritus': {
    id: 'prospectus.2u-product-card.pill-text.emeritus',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Offered on Emeritus',
  },
  'prospectus.2u-product-card.footer-text.shorelight': {
    id: 'prospectus.2u-product-card.pill-text.shorelight',
    description: 'Text on a product card that describes which product line this item belongs to',
    defaultMessage: 'Offered through Shorelight',
  },
  'prospectus.2u-product-card.footer-text.number-of-courses': {
    id: 'prospectus.2u-product-card.footer-text.number-of-courses',
    description: 'Label in card footer that shows how many courses are in a program',
    defaultMessage: '{length} {label}',
  },
});

export const externalLinkIconCopy = defineMessages({
  'prospectus.2u-product-card.launch-icon.sr-text': {
    id: 'prospectus.2u-product-card.launch-icon.sr-text',
    description: 'Screen reader text for the launch icon on the cards',
    defaultMessage: 'Opens a link in a new tab',
  },
});
